import { useProfileStore } from "../../stores/UserStore";
import { Text } from "@mantine/core";

const ProfileTimezone = ({ disabled, timezone }) => {
  const profile = useProfileStore((s) => s.profile);
  if (profile.timezone || timezone)
    return (
      <Text c={disabled ? "dimmed" : "black"} mr={6}>
        ({timezone || profile.timezone})
      </Text>
    );
  return "";
};

export default ProfileTimezone;
